// extracted by mini-css-extract-plugin
export default {"menuItemContainer":"sidebar_menuItemContainer__e1RbN"};